import { SIZE, ORIENTATION } from 'app-v2/design-tokens'
import React from 'react'
import { StyledSpacer } from './styles'

export type SpacerProps = {
    size?: string,
    orientation?: string
}
export const Spacer = ({
    size = SIZE.M,
    orientation = ORIENTATION.VERTICAL,
    ...viewProps
}: SpacerProps) => {
    return <StyledSpacer size={size} orientation={orientation} {...viewProps} />
}
